/**
 * InputMonitorToggle Component
 * Input monitoring toggle with level meter - works for live monitoring AND recording
 */

import React from 'react';
import { Button } from '../../ui/button';
import { Headphones } from 'lucide-react';

export const InputMonitorToggle = ({
  inputMonitorEnabled,
  setInputMonitorEnabled,
  isRecording = false,
  inputLevel = 0,
}) => {
  return (
    <div className="relative group flex items-center gap-1">
      <Button
        variant={inputMonitorEnabled ? 'default' : 'ghost'}
        size="sm"
        onClick={() => {
          setInputMonitorEnabled(!inputMonitorEnabled);
        }}
        className={`relative p-2 ${inputMonitorEnabled ? 'bg-amber-500/20 text-amber-400 border border-amber-500/50' : 'text-zinc-400 hover:text-white'}`}
        data-testid="input-monitor-toggle"
        title={inputMonitorEnabled ? 'Click to disable monitoring' : 'Click to hear your guitar'}
      >
        <Headphones className="w-5 h-5" />
        {inputMonitorEnabled && (
          <span className="absolute -top-1 -right-1 w-2 h-2 bg-amber-400 rounded-full animate-pulse" />
        )}
      </Button>
      
      {/* Input Level Meter - shows when monitoring OR recording */}
      {(inputMonitorEnabled || isRecording) && (
        <div className="w-16 h-5 bg-zinc-800 rounded overflow-hidden border border-zinc-700">
          <div
            className={`h-full transition-all duration-75 ${
              inputLevel > 0.8 ? 'bg-red-500' : inputLevel > 0.6 ? 'bg-amber-500' : 'bg-emerald-500'
            }`}
            style={{ width: `${Math.min(inputLevel * 100, 100)}%` }}
          />
        </div>
      )}
    </div>
  );
};

export default InputMonitorToggle;
